/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelTournamentWithdrawalBody
 */
export interface CancelTournamentWithdrawalBody {
    /**
     * 
     * @type {string}
     * @memberof CancelTournamentWithdrawalBody
     */
    reason?: string;
}

/**
 * Check if a given object implements the CancelTournamentWithdrawalBody interface.
 */
export function instanceOfCancelTournamentWithdrawalBody(value: object): value is CancelTournamentWithdrawalBody {
    return true;
}

export function CancelTournamentWithdrawalBodyFromJSON(json: any): CancelTournamentWithdrawalBody {
    return CancelTournamentWithdrawalBodyFromJSONTyped(json, false);
}

export function CancelTournamentWithdrawalBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelTournamentWithdrawalBody {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function CancelTournamentWithdrawalBodyToJSON(json: any): CancelTournamentWithdrawalBody {
    return CancelTournamentWithdrawalBodyToJSONTyped(json, false);
}

export function CancelTournamentWithdrawalBodyToJSONTyped(value?: CancelTournamentWithdrawalBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
    };
}

